import { useEffect } from 'react';
import MessagesPlugin from '../models/messages';

/**
 * Hook che effettua la registrazione e deregistrazione di un handler a Plugin
 * @param {func} handleMessages gestore dei messaggi
 */
const usePluginHandler = (handleMessages) => {
  useEffect(() => {
    if (!handleMessages) return () => {};
    MessagesPlugin.subscribe(handleMessages);
    return () => {
      MessagesPlugin.unsubscribe(handleMessages);
    };
  }, [handleMessages]);
};

export default usePluginHandler;
